import React, { useEffect, useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { DashboardHeader } from './components/DashboardHeader';
import { KPISection } from './components/KPISection';
import { ChartSection } from './components/ChartSection';
import { AlertSection } from './components/AlertSection';
import { UsersPage } from './pages/UsersPage';
import { BookingsPage } from './pages/BookingsPage';
import { ServicesPage } from './pages/ServicesPage';
import { FinancialsPage } from './pages/FinancialsPage';
import { CouponsPage } from './pages/CouponsPage';
import { CustomerSupportPage } from './pages/CustomerSupportPage';
import { AlertsPage } from './pages/AlertsPage';
import { LoginPage } from './pages/LoginPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Check for existing auth on mount
  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
    setCurrentPage('dashboard');
  };
  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} data-id="element-0" />;
  }
  return <div className="flex h-screen bg-gray-50" data-id="element-1">
      <Sidebar currentPage={currentPage} onNavigate={setCurrentPage} onLogout={handleLogout} data-id="element-2" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-3">
        <DashboardHeader data-id="element-4" />
        <main className="flex-1 overflow-y-auto" data-id="element-5">
          {currentPage === 'dashboard' && <div className="p-4" data-id="element-6">
              <div className="max-w-7xl mx-auto" data-id="element-7">
                <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-8">
                  Dashboard
                </h1>
                <KPISection data-id="element-9" />
                <ChartSection data-id="element-10" />
                <AlertSection onNavigate={setCurrentPage} data-id="element-11" />
              </div>
            </div>}
          {currentPage === 'users' && <UsersPage data-id="element-12" />}
          {currentPage === 'bookings' && <BookingsPage data-id="element-13" />}
          {currentPage === 'services' && <ServicesPage data-id="element-14" />}
          {currentPage === 'financials' && <FinancialsPage data-id="element-15" />}
          {currentPage === 'coupons' && <CouponsPage data-id="element-16" />}
          {currentPage === 'support' && <CustomerSupportPage data-id="element-17" />}
          {currentPage === 'alerts' && <AlertsPage onNavigate={setCurrentPage} data-id="element-18" />}
        </main>
      </div>
    </div>;
}